import React, { useEffect, useRef } from "react";
import Chart from "chart.js/auto";

const LineChart = ({ labels, data }) => {
  const chartContainer = useRef(null);

  // Convert y values to Date objects
  const dates = data.map((dateStr) => new Date(dateStr));

  useEffect(() => {
    if (chartContainer && chartContainer.current) {
      const myChart = new Chart(chartContainer.current, {
        type: "line",
        data: {
          labels: labels,
          datasets: [
            {
              label: "Company Histroy",
              data: data,
              fill: true,
              borderWidth: 0.5,
              pointBackgroundColor: "#361e42",
              backgroundColor: "rgba(37, 150, 190, 0.3)",
              borderColor: "rgb(75, 192, 192)",
              tension: 0.1,
            },
          ],
        },

        options: {
          responsive: true,
          maintainAspectRatio: false,
          plugins: {
            legend: {
              position: "top",
            },
            filler: {
              propagate: false,
            },
            title: {
              display: true,
              text: "Company History",
            },
          },
        },
      });
      return () => {
        myChart.destroy();
      };
    }
  }, []);

  return <canvas ref={chartContainer} />;
};

export default LineChart;
